import { useSelector } from 'react-redux';
import type { RootState } from '../../store/store';
import { Navigate } from 'react-router-dom';

export const AdminComponent = ({ children }: { children: React.ReactNode }) => {
  const { isAuthenticated, user } = useSelector((state: RootState) => state.auth);

  if (!isAuthenticated) {
    return <Navigate to='/login' replace />;
  }

  // Check if user has the admin role (using the exact string from backend enum)
  if (!user?.roles.includes('admin')) {
    return <Navigate to='/' replace />;
  }

  return children;
};
